import { DataTable } from '../../../../Component/Common/Components/DataTable/DataTable';
import { IBulkActions } from '../../../../Component/Model/Table/Table';
import { IPositionsTable } from './PositionsTableColumns';



interface IPositionsDataTable {
    data: IPositionsTable;
    isLoading: boolean;
    counter: number;
    bulkActions: IBulkActions[];
}

export const PositionsDataTable = (props: IPositionsDataTable) => {
    return (
        <>
            <DataTable
                bulkActions={props.bulkActions}
                showTotalEntries={false}
                key={props.counter}
                table={props.data}
                entriesPerPage={{ defaultValue: 10 }}
                pageNumber={1}
                totalItemsCount={props.data.rows.length}
                entriesPerPageChanged={(entriesPerPage: number) => { }}
                pageNumberChanged={(pageNumber: number) => { }}
                isLoading={props.isLoading}
                filteredItemsCount={props.data.rows.length}
            ></DataTable>
        </>)

}